import ProduitDetailController from './produit.detail.controller';

export default {
    template: require('./produit.detail.html'),
    controller: ProduitDetailController
};
